import React from 'react';
import AudioPauseIcon from '../../images/svg-gcbooks/audio-pause-icon';
import AudioPlayIcon from '../../images/svg-gcbooks/audio-play-icon';
import HeadPhoneIcon from '../../images/svg-gcbooks/headphone-icon';
import { useBookAudioPlayer } from '../../context/bookAudioPlayerContext';
import './audioToggleButton.scss';

export default function AudioToggleButton({ text, audioDetails }) {
  const { toggle, audioState, currentAudioId, isLoading, error, selectedVoice } = useBookAudioPlayer();

  if (
    !audioDetails ||
    (!audioDetails.audioByCharleneId && !audioDetails.audioByCallieId && !audioDetails.audioByNancyId)
  ) {
    return null;
  }

  const getSelectedAudioId = () => {
    if (selectedVoice === 'Charlene') return audioDetails?.audioByCharleneId;
    if (selectedVoice === 'Callie') return audioDetails?.audioByCallieId;
    if (selectedVoice === 'Nancy') return audioDetails?.audioByNancyId;
    return audioDetails?.audioByCharleneId;
  };

  const isCurrentAudio = currentAudioId === getSelectedAudioId();

  const getButtonContent = () => {
    if (isLoading && isCurrentAudio) {
      return {
        icon: <HeadPhoneIcon />,
        text: 'Loading...',
      };
    } else if (audioState === 'playing' && isCurrentAudio) {
      return {
        icon: <AudioPauseIcon />,
        text: 'Pause Audio',
      };
    } else if (audioState === 'paused' && isCurrentAudio) {
      return {
        icon: <AudioPlayIcon />,
        text: 'Resume Audio',
      };
    } else {
      return {
        icon: <HeadPhoneIcon />,
        text: text || 'Listen',
      };
    }
  };

  const content = getButtonContent();

  return (
    <div className="audio-toggle-wrapper">
      <button
        onClick={() => toggle(audioDetails)}
        className="audio-toggle-button"
        disabled={isLoading && isCurrentAudio}
      >
        {content.icon}
        <span>{content.text}</span>
      </button>
      {error && isCurrentAudio && (
        <div className="audio-error-message" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
          {error}
        </div>
      )}
    </div>
  );
}
